"use strict";

require("core-js/es6/map");

require("core-js/es6/set");